module.exports = __webpack_public_path__ + "img/banner-contact-port.749f8eb2.png";